module.exports = __webpack_public_path__ + "static/antd-datepicker-borderless-889c08e395009492fe7034bd5207d281.png";